import { dashboardIcon1, dashboardIcon4 } from 'assets/icons'
import React from 'react'

const DashboardTabs = ({ dashboardData }) => {
    // console.log('dashboardData', dashboardData)
    return (
        <>
            <div className="summery_card_wrap mb-3">
                <div className="summery_card">
                {/* <div className="summery_card text-bg-secondary text-white p-3 rounded"> */}
                {/* <div className="summery_card shadow p-3 bg-white rounded"
                    style={{ boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.6)" }}
                > */}

                    <div className="content ">
                        <p>Total User</p>
                        {/* <img src={dashboardIcon1} alt="" /> */}
                    </div>
                    <h4>{dashboardData?.totalUsers ?? 0}</h4>
                </div>
                <div className="summery_card">
                    <div className="content">
                        <p>Active Users</p>
                    </div>
                    <h4>{dashboardData?.activeUsers ?? 0}</h4>
                </div>
                <div className="summery_card">
                    <div className="content">
                        <p>In Active Users</p>
                    </div>
                    <h4>{dashboardData?.inActiveUsers ?? 0}</h4>
                </div>
                <div className="summery_card">
                    <div className="content">
                        <p>Total Category</p>
                    </div>
                    <h4>{dashboardData?.categoryCount ?? 0}</h4>
                </div>
                <div className="summery_card">
                    <div className="content">
                        <p>Total Sales</p>
                    </div>
                    {/* <h4>{dashboardData?.totalSales ? dashboardData?.totalSales?.toFixed(2) : 0}</h4> */}
                    <h4>{Number(dashboardData?.totalSales || 0).toFixed(2)}</h4>

                </div>
            </div>

            <div className="summery_card_wrap mb-3">
                <div className="summery_card">
                {/* <div className="summery_card text-bg-secondary text-white p-3 rounded"> */}
                {/* <div className="summery_card shadow p-3 bg-white rounded"
                    style={{ boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.6)" }}
                > */}
                    <div className="content">
                        <p>Total Orders</p>
                    </div>
                    <h4>{dashboardData?.totalOrders ?? 0}</h4>
                </div>
                <div className="summery_card">
                    <div className="content">
                        <p>Delivered  Orders</p>
                    </div>
                    <h4>{dashboardData?.deliveredOrders ?? 0}</h4>
                </div>

                <div className="summery_card">
                    <div className="content">
                        <p>Pending Order</p>
                        {/* <img src={dashboardIcon1} alt="" /> */}
                    </div>
                    <h4>{dashboardData?.pendingOrders ?? 0}</h4>
                </div>
                   <div className="summery_card">
                    <div className="content">
                        <p>Cancelled  Orders</p>
                    </div>
                    <h4>{dashboardData?.cancelledOrders ?? 0}</h4>
                </div>

                <div className="summery_card">
                    <div className="content">
                        <p>Home Delivery</p>
                    </div>
                    <h4>{dashboardData?.homeDelivery ?? 0}</h4>
                </div>
             
                <div className="summery_card">
                    <div className="content">
                        <p>Store Pick-Up</p>
                    </div>
                    <h4>{dashboardData?.storePickup ?? 0}</h4>
                </div>

            </div>

            {/* <div className="summery_card_wrap mb-3">
            </div> */}
        </>
    )
}

export default DashboardTabs